export const OPEN_DELETE_DIALOG = "modalActions::openDeleteDialog";
export const CLOSE_DELETE_DIALOG = "modalActions::closeDeleteDialog";

export const openDeleteDialog = selectedIds => {
  return {
    type: OPEN_DELETE_DIALOG,
    payload: {
      selectedIds
    }
  };
};

export const closeDeleteDialog = () => {
  return {
    type: CLOSE_DELETE_DIALOG
  };
};
